import { brown1, gray12 } from 'assets/stylesheets/base/_colors';
import { get } from 'lodash';
import Generator from './generator';

export default class ForecastCureGenerator extends Generator {
  _getForecastSeriesData(objectArray) {
    const forecastedKey = 'forecastEnrollmentMidQuantile';

    const enrolmentSeriesData = {
      forecast: this._getSeriesData(objectArray, forecastedKey),
    };

    return enrolmentSeriesData;
  }

  _generateAreaChart(objectArray) {
    const pt0Key = 'forecastEnrollmentUpperQuartile';
    const shadedAreaTopLimits = this._getSeriesData(objectArray, pt0Key, false);

    const pt1key = 'forecastEnrollmentLowerQuartile';
    const shadedAreaBottomLimits = this._getSeriesData(
      objectArray,
      pt1key,
      false,
    );

    const combinedAreaData = [];
    shadedAreaTopLimits.forEach((topPoint, index) => {
      combinedAreaData.push([
        topPoint.x,
        shadedAreaBottomLimits[index].y,
        topPoint.y,
      ]);
    });

    return combinedAreaData;
  }

  _generateVerticalAreaChart(forecastLowerPoint, forecastUpperPoint) {
    const areaSeriesData = [];
    const forecastLowerPointX = forecastLowerPoint;
    const forecastUpperPointX = forecastUpperPoint;

    if (!forecastLowerPointX || !forecastUpperPointX) {
      return areaSeriesData;
    }
    areaSeriesData.push({ x: forecastLowerPointX, y: 1e7 });
    areaSeriesData.push({ x: forecastUpperPointX, y: 1e7 });

    return areaSeriesData;
  }

  _generateForecastRange(forecastMetrics) {
    let forecastStartRangeDate = get(
      forecastMetrics.find(
        (item) => get(item, 'metric') === 'FORECAST_LSI_RANGE_START',
      ),
      'value',
      null,
    );
    let forecastEndRangeDate = get(
      forecastMetrics.find(
        (item) => get(item, 'metric') === 'FORECAST_LSI_RANGE_END',
      ),
      'value',
      null,
    );

    if (!forecastStartRangeDate || !forecastEndRangeDate) {
      return { forecastLowerPoint: null, forecastUpperPoint: null };
    }
    forecastStartRangeDate = forecastStartRangeDate.replace(/-\d{2}$/, '-03');
    forecastEndRangeDate = forecastEndRangeDate.replace(/-\d{2}$/, '-03');
    const forecastLowerPoint = new Date(forecastStartRangeDate);
    const forecastUpperPoint = new Date(forecastEndRangeDate);
    return { forecastLowerPoint, forecastUpperPoint };
  }

  getSeries(objectArray, forecastMetrics) {
    const lineSeriesData = this._getForecastSeriesData(objectArray);
    const { forecastLowerPoint, forecastUpperPoint } =
      this._generateForecastRange(forecastMetrics);
    const areaSeriesData = this._generateVerticalAreaChart(
      forecastLowerPoint,
      forecastUpperPoint,
    );

    const forecastedLine = {
      id: null,
      name: 'Forecast',
      type: 'line',
      data: lineSeriesData.forecast,
      color: brown1,
      enableMouseTracking: true,
      showInLegend: false,
      dashStyle: 'ShortDash',
      customTags: ['enrollment', 'forecast'],
      linkedTo: 'actualEnrollment',
      yAxis: 1,
      zIndex: 3,
    };

    const areaChart = {
      name: 'Forecast LSI range',
      data: areaSeriesData,
      type: 'area',
      color: gray12,
      zIndex: 1,
      yAxis: 1,
      showInLegend: false,
      enableMouseTracking: true,
      states: {
        inactive: {
          enabled: false,
        },
      },
      linkedTo: 'actualEnrollment',
      customTags: ['enrollment', 'forecast_area_range'],
    };

    const forecastSeries = [areaChart, forecastedLine];

    return forecastSeries;
  }
}
